module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/purebarre-5b73dce3be6c76c4edfc3185a61567f4.png";